<div class="user-management-container">
  <!-- Header -->
  <div class="user-management-header">
    <div class="header-content">
      <button class="btn btn-secondary back-btn" (click)="goBack()">
        <i class="material-icons">arrow_back</i>
        Back to Dashboard
      </button>

      <h1 class="page-title">
        <i class="material-icons">people</i>
        User Management
      </h1>

      <button class="btn btn-primary refresh-btn" [disabled]="isLoading" (click)="refreshUsers()">
        <i class="material-icons" [class.spinning]="isLoading">refresh</i>
        Refresh
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="user-management-content">
    <!-- Loading State -->
    <div class="loading-container" *ngIf="isLoading && users.length === 0">
      <i class="material-icons spinning">hourglass_empty</i>
      <p>Loading users...</p>
    </div>

    <!-- Error State -->
    <div class="error-container" *ngIf="error">
      <i class="material-icons">error</i>
      <h3>Error Loading Users</h3>
      <p>{{ error }}</p>
      <button class="btn btn-primary" (click)="refreshUsers()">
        <i class="material-icons">refresh</i>
        Retry
      </button>
    </div>

    <!-- Users Table -->
    <div class="table-container" *ngIf="!isLoading && !error && users.length > 0">
      <!-- Pagination Info -->
      <div class="pagination-info" *ngIf="pagination">
        <span>
          Showing {{ (pagination.current_page - 1) * pagination.page_size + 1 }} -
          {{ getPaginationEnd() }}
          of {{ pagination.total_users }} users
        </span>
      </div>

      <!-- Table -->
      <div class="table-wrapper">
        <table class="users-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Username</th>
              <th>Email</th>
              <th>Name</th>
              <th>Status</th>
              <th>Subscription</th>
              <th>Sub. Start</th>
              <th>Sub. End</th>
              <th>Country</th>
              <th>Languages</th>
              <th>Joined</th>
              <th>Last Login</th>
            </tr>
          </thead>
          <tbody>
            <tr class="user-row" *ngFor="let user of users; trackBy: trackByUserId">
              <td class="user-id">{{ user.id }}</td>

              <td class="username">
                <div class="user-info">
                  <div class="avatar">
                    <img
                      *ngIf="user.has_profile_pic && user.profile_pic_url; else defaultAvatar"
                      [alt]="user.username"
                      [src]="assets + user.profile_pic_url"
                      (error)="onImageError($event)"
                    />
                    <ng-template #defaultAvatar>
                      <img
                        src="https://st3.depositphotos.com/6672868/13701/v/600/depositphotos_137014128-stock-illustration-user-profile-icon.jpg"
                        [alt]="user.username"
                      />
                    </ng-template>
                  </div>
                  <span class="username-text">{{ user.username }}</span>
                </div>
              </td>

              <td class="email">{{ user.email || 'N/A' }}</td>

              <td class="name">
                {{ (user.first_name || '') + ' ' + (user.last_name || '') || 'N/A' }}
              </td>

              <td class="status">
                <span class="status-badge" [ngClass]="getStatusBadgeClass(user)">
                  {{ getStatusText(user) }}
                </span>
              </td>

              <td class="subscription">
                <span class="subscription-badge" [ngClass]="getSubscriptionBadgeClass(user)">
                  {{ user.subscription || 'Free Tier' }}
                </span>
              </td>

              <td class="subscription-start">{{ formatDate(user.subscription_start) }}</td>

              <td class="subscription-end">
                <span [ngClass]="getSubscriptionEndClass(user)">
                  {{ formatDate(user.subscription_end) }}
                </span>
              </td>

              <td class="country">
                <div class="location">
                  <span *ngIf="user.country">{{ user.country }}</span>
                  <span *ngIf="user.country && user.city">, </span>
                  <span *ngIf="user.city">{{ user.city }}</span>
                  <span *ngIf="!user.country && !user.city">N/A</span>
                </div>
              </td>

              <td class="languages">
                <div class="language-list">
                  <ddc-country-flag *ngIf="user.language_1" [ddc_lng]="user.language_1"></ddc-country-flag>
                  <ddc-country-flag *ngIf="user.language_2" [ddc_lng]="user.language_2"></ddc-country-flag>
                  <ddc-country-flag *ngIf="user.language_3" [ddc_lng]="user.language_3"></ddc-country-flag>
                  <span *ngIf="!user.language_1 && !user.language_2 && !user.language_3">N/A</span>
                </div>
              </td>

              <td class="joined">{{ formatDate(user.date_joined) }}</td>

              <td class="last-login">{{ formatDate(user.last_login) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
      <div class="pagination-container" *ngIf="pagination && pagination.total_pages > 1">
        <div class="pagination-controls">
          <!-- Previous Button -->
          <button class="btn btn-pagination" [disabled]="!pagination.has_previous" (click)="goToPreviousPage()">
            <i class="material-icons">chevron_left</i>
            Previous
          </button>

          <!-- Page Numbers -->
          <div class="page-numbers">
            <button
              class="btn btn-page-number"
              *ngFor="let page of getPageNumbers()"
              [class.active]="page === pagination.current_page"
              [disabled]="page === -1"
              (click)="page !== -1 ? goToPage(page) : null"
            >
              <span *ngIf="page === -1">...</span>
              <span *ngIf="page !== -1">{{ page }}</span>
            </button>
          </div>

          <!-- Next Button -->
          <button class="btn btn-pagination" [disabled]="!pagination.has_next" (click)="goToNextPage()">
            Next
            <i class="material-icons">chevron_right</i>
          </button>
        </div>

        <div class="pagination-summary">Page {{ pagination.current_page }} of {{ pagination.total_pages }}</div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-container" *ngIf="!isLoading && !error && users.length === 0">
      <i class="material-icons">people_outline</i>
      <h3>No Users Found</h3>
      <p>There are no users in the system.</p>
    </div>
  </div>
</div>
